// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Avatar.module.scss  */
.Avatar-module-Root_aqW {
  position: relative;
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  padding: 0;
  color: #fff;
  border: none;
  border-radius: 50%;
  outline: none;
  /* stylelint-disable */
  background: linear-gradient(30deg, #8168f0 17.93%, #7f6df0 26.99%, #787af0 37.27%, #6c91f1 48.15%, #5db1f1 59.43%, #48d9f2 70.93%, #46def2 72.14%, #50e3c2 84.08%);
  /* stylelint-enable */ }
  .Avatar-module-Root_aqW img {
    width: 100%;
    height: 100%;
    object-fit: cover; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Avatar/Avatar.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kKAAkK;EAClK,qBAAqB,EAAE;EACvB;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAE","sourcesContent":["/*  imported from Avatar.module.scss  */\n.Avatar-module-Root_aqW {\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  justify-content: center;\n  align-items: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  color: #fff;\n  border: none;\n  border-radius: 50%;\n  outline: none;\n  /* stylelint-disable */\n  background: linear-gradient(30deg, #8168f0 17.93%, #7f6df0 26.99%, #787af0 37.27%, #6c91f1 48.15%, #5db1f1 59.43%, #48d9f2 70.93%, #46def2 72.14%, #50e3c2 84.08%);\n  /* stylelint-enable */ }\n  .Avatar-module-Root_aqW img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
